import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useBreakpoint } from '@/hooks/useBreakpoint.ts';
import { MainMenu } from '@/components/Menu/MainMenu';
import { useTenantID } from '@/hooks/useTenantID';
import { useBranding } from '@/hooks/useBranding';
import Button from '@/components/core/Button';
import { FormattedMessage } from 'react-intl';
import { IconArrowLeft } from '@/icons';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute('/$tenantId/menu/')({
  component: Menu,
});

function Menu() {
  const isTablet = useBreakpoint(1024);
  const tenantId = useTenantID();
  const branding = useBranding();

  if (!isTablet) {
    return <Navigate to="/$tenantId" params={{ tenantId }} />;
  }

  return (
    <>
      <DocumentHead
        titleKey="page.menu.title"
        descriptionKey="page.menu.description"
      />
      <div className="flex h-screen w-full shrink-0 flex-col">
        <div className="h-28 w-full">
          <div className="h-[100px] w-full overflow-hidden">
            {branding?.logo}
          </div>
        </div>

        <Button
          to="/$tenantId"
          params={{ tenantId }}
          variant="ghost"
          className="w-full"
          startIcon={<IconArrowLeft />}
        >
          <FormattedMessage defaultMessage="Tillbaka" />
        </Button>

        <MainMenu />
      </div>
    </>
  );
}
